import LodRfdView from "components/view/lod/rfd/list";
import { lodRfdSearchInfoProps } from "interface/lod";
import { useState } from "react";
import { useLocation } from "react-router-dom";

const LodRfdPage = () => {
  const { pathname } = useLocation();
  const memType = pathname.includes("admin") ? "admin" : "manager";
  const [searchInfo, setSearchInfo] = useState<lodRfdSearchInfoProps>({
    lodGrdCd: "",
    lodGrpNo: "",
    lodNo: "",
    refdFeeTypCd: "",
    uYn: "N",
  });
  const handleChange = (name: string, value: string) => {};
  const handleSelect = (target: EventTarget & HTMLLIElement) => {};
  const handleReset = () => {};
  const handleSearch = () => {};
  return (
    <LodRfdView
      memType={memType}
      searchInfo={searchInfo}
      handleChange={handleChange}
      handleSelect={handleSelect}
      handleReset={handleReset}
      handleSearch={handleSearch}
    />
  );
};

export default LodRfdPage;
